export default {
  'customListGroup.title': 'Manage List Groups',

  'customListGroup.form.id': 'ID',
  'customListGroup.form.enable': 'Enable',
  'customListGroup.form.name': 'Name',
  'customListGroup.form.description': 'Description',

  'customListGroup.form.statusLabel': 'Enabled Element?',

  'customListGroup.enabled': 'Enabled',
  'customListGroup.disabled': 'Disabled',
};
